import { AppNS } from 'app';

import { PayloadAction } from '@reduxjs/toolkit';

import { AuthState } from '../../auth';

export const PUBLIC_DETAILS_DATA_REDUCERS = {
  setPublicDetailsDataStart(state: AuthState) {
    state.isChangingPublicDetailsData = true;
    state.isChangingPublicDetailsDataError = false;
  },
  setPublicDetailsDataFailed(state: AuthState) {
    state.isChangingPublicDetailsDataError = true;
  },
  setPublicDetailsDataSuccess(
    state: AuthState,
    action: PayloadAction<{
      name: string;
      website: string;
      address: AppNS.Address;
    }>
  ) {
    state.isChangingPublicDetailsData = false;
    state.isChangingPublicDetailsDataError = false;
    if (state.user?.company) {
      state.user.company = {
        ...state.user.company,
        companyName: action.payload.name,
        website: action.payload.website,
        address: [action.payload.address],
      };

      const companyId = state.user.company.id;
      if (companyId) {
        state.user.employments = state.user.employments.map((employment) => {
          if (employment.companyId === companyId) {
            return {
              ...employment,
              company: {
                ...employment.company,
                companyName: action.payload.name,
                website: action.payload.website,
                address: [action.payload.address],
              },
            };
          }
          return employment;
        });
      }
    }
  },
};
